import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BlockLegend } from '../../Components/Public/Blocks/BlockLegend.js';
import { BlockLogoCharacters } from '../../Components/Public/Logos/BlockLogoCharacters.js';
import { BlockLogoAttraction } from '../../Components/Public/Logos/BlockLogoAttraction.js';
import { BlockTitleDate1Link1 } from '../../Components/Public/Blocks/BlockTitleDate1Link1.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Family = (props) => {
    const { navParks, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [family, setFamily] = useState([]);
    const [attractions, setAttractions] = useState([]);
    const [characters, setCharacters] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasFamily = await fetch(`${backend}/family?id=${id}`, GetHeaders(guest));
            const family = await datasFamily.json();
            setFamily(family);
            const datasAttractions = await fetch(`${backend}/attractions_by_family?id=${id}`, GetHeaders(guest));
            const attractions = await datasAttractions.json();
            setAttractions(attractions);
            const datasCharacters = await fetch(`${backend}/characters_by_family?id=${id}`, GetHeaders(guest));
            const characters = await datasCharacters.json();
            setCharacters(characters);
        };
        fetchData();
        ScrollTop();
    }, [backend, id, guest]);
    const total = attractions.length + characters.length;
    const items = GetDescription('family', { family: family, attractions: attractions, characters: characters })
    const title_list = `${items.fname}: ${attractions.length} attractions - ${characters.length} personnages`;
    return (
        <div className="family">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="family" />
            <section className="infos">
                <div className="list">
                    <div className="title-list">{title_list}</div>
                    <BlockLegend parks={navParks} total={total} />
                    {attractions.map((item, i) => {
                        return (
                            <BlockLogoAttraction label="family" item={item} key={`a-${i}`} />
                        )
                    })}
                    {characters.map((item, i) => {
                        return (
                            <BlockLogoCharacters label="family" item={item} key={`c-${i}`} />
                        )
                    })}
                </div>
                <div className="description">
                    <BlockTitleDate1Link1 label="family" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}